"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FreeReturnsPolicy = void 0;
const react_1 = __importStar(require("react"));
const bottom_sheet_1 = require("../bottom-sheet");
const caret_1 = require("../caret");
const link_1 = require("../link");
const list_1 = require("../list");
const popover_1 = require("../popover");
const themed_text_1 = require("../themed-text");
const styles_1 = require("./styles");
const FreeReturnsPolicy = (props) => {
    const { primaryMessage, description } = props;
    const [showTooltip, setShowTooltip] = (0, react_1.useState)(false);
    const [showReturnInstructions, setShowReturnInstructions] = (0, react_1.useState)(false);
    const [instructionsStepsCaretDirection, setInstructionsStepsCaretDirection] = (0, react_1.useState)(caret_1.CaretDirection.Down);
    const jsxElementArray = [];
    const [descriptionItems, setDescriptionItems] = (0, react_1.useState)(jsxElementArray);
    const [bubbleNotchHorizontalPosition, setBubbleNotchHorizontalPosition] = (0, react_1.useState)('');
    (0, react_1.useEffect)(() => {
        showReturnInstructions
            ? setInstructionsStepsCaretDirection(caret_1.CaretDirection.Up)
            : setInstructionsStepsCaretDirection(caret_1.CaretDirection.Down);
    }, [showReturnInstructions]);
    (0, react_1.useEffect)(() => {
        var _a;
        const tempDescriptionItems = [];
        if (description === null || description === void 0 ? void 0 : description.text) {
            tempDescriptionItems.push(react_1.default.createElement(themed_text_1.ThemedSpan, { color: "base", font: "base" }, description === null || description === void 0 ? void 0 : description.text));
        }
        if (description === null || description === void 0 ? void 0 : description.link) {
            tempDescriptionItems.push(react_1.default.createElement(themed_text_1.ThemedSpan, { color: "link", font: "base" },
                react_1.default.createElement(link_1.Link, { href: description === null || description === void 0 ? void 0 : description.link, id: "LearnMoreFreeReturnsPolicy" }, description === null || description === void 0 ? void 0 : description.learnMore)));
        }
        const primaryMessageWidth = (_a = document.getElementById('freeReturnsPolicyPrimaryMessage')) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width;
        const notchHorizontalPosition = primaryMessageWidth ? Math.floor(primaryMessageWidth / 2) : 10;
        setBubbleNotchHorizontalPosition(notchHorizontalPosition.toString());
        setDescriptionItems(tempDescriptionItems);
    }, []);
    const activateTooltip = () => {
        setShowTooltip(true);
    };
    const deactivateTooltip = () => {
        setShowTooltip(false);
        setShowReturnInstructions(false);
    };
    const displayReturnInstructions = () => {
        const showSteps = showReturnInstructions;
        setShowReturnInstructions(!showSteps);
    };
    return primaryMessage ? (react_1.default.createElement(styles_1.FreeReturnsPolicyContainer, null,
        react_1.default.createElement(styles_1.FreeReturnsPolicyPrimaryMessageContainer, { "data-cy": "free-returns-policy-primary-message", "aria-label": "tooltip", "aria-description": "Click to view free returns policy description" },
            react_1.default.createElement(styles_1.FreeReturnsPolicyPrimaryMessage, { id: "freeReturnsPolicyPrimaryMessage", color: "link", font: "base", onClick: activateTooltip },
                primaryMessage,
                " ",
                react_1.default.createElement(caret_1.Caret, { size: "small", rotation: caret_1.CaretDirection.Down }))),
        showTooltip ? (react_1.default.createElement(FreeReturnsPolicyResponsivePopover, Object.assign({ bubbleNotchHorizontalPosition: bubbleNotchHorizontalPosition, showTooltip: showTooltip, deactivateTooltip: deactivateTooltip }, props),
            react_1.default.createElement(FreeReturnsPolicyDetails, Object.assign({ descriptionItems: descriptionItems, displayReturnInstructions: displayReturnInstructions, instructionsStepsCaretDirection: instructionsStepsCaretDirection, showReturnInstructions: showReturnInstructions }, props)))) : null)) : null;
};
exports.FreeReturnsPolicy = FreeReturnsPolicy;
const FreeReturnsPolicyDetails = (props) => {
    const { mobileView, descriptionItems, returnInstructions, displayReturnInstructions, instructionsStepsCaretDirection, showReturnInstructions } = props;
    const getReturnSteps = (instructions) => {
        if (instructions && instructions.steps) {
            return instructions.steps.map((step) => step.value);
        }
        return [];
    };
    const returnInstructionsSteps = (0, react_1.useMemo)(() => getReturnSteps(returnInstructions), [returnInstructions]);
    return (react_1.default.createElement(styles_1.FreeReturnsPolicyPopoverContainer, { mobileView: mobileView },
        react_1.default.createElement(list_1.List, { id: "freeReturnsPolicyDescription", items: descriptionItems, decorated: false, margin: "0", padding: "0" }),
        returnInstructions && returnInstructions.title ? (react_1.default.createElement("div", null,
            react_1.default.createElement(styles_1.ReturnInstructionsTitle, { "aria-label": "open", onClick: displayReturnInstructions },
                react_1.default.createElement(caret_1.Caret, { rotation: instructionsStepsCaretDirection }),
                " ", returnInstructions === null || returnInstructions === void 0 ? void 0 :
                returnInstructions.title),
            showReturnInstructions ? (react_1.default.createElement(styles_1.ReturnInstructionsStepsContainer, null,
                react_1.default.createElement(list_1.List, { ordered: true, id: "freeReturnsPolicySteps", items: returnInstructionsSteps, padding: "0 0 0 20px", margin: "0" }))) : null)) : null));
};
const FreeReturnsPolicyResponsivePopover = (props) => {
    const { bubbleNotchHorizontalPosition, mobileView, title, showTooltip, deactivateTooltip, children } = props;
    return mobileView ? (react_1.default.createElement(bottom_sheet_1.BottomSheet, { headerText: title, isOpen: showTooltip, onClose: deactivateTooltip }, children)) : (react_1.default.createElement(popover_1.Popover, { bubbleNotchHorizontalPosition: bubbleNotchHorizontalPosition, closePopover: deactivateTooltip, headerText: title }, children));
};
